export enum StartWithUnit {
    /** Auth */
    SignIn,
    AddPtTicket,
    CancelPtTicket,
    TopUpByToken,
    BuyTicket,
    SellOrRegisterCard,
    ClientSearch,
    OpenShift,
    LogOut,
}
